import { hexToRGB } from "src/lib/colors";

const THEMES = {
	primary: "bg-primary text-white",
	dark: "bg-dark text-white",
	gray: "bg-gray",
	white: "bg-white text-dark",
	red: "bg-red text-white",
};

const SIZES = {
	xsmall: "leading-[8px] text-[12px] py-2 px-2 rounded-md",
	small: "leading-[10px] text-[14px] py-[11px] px-[10px]",
	default: "leading-[10px] text-[16px] py-[11px] px-[10px]",
	regular: "leading-[10px] text-[16px] py-3 px-[14px]",
	large: "leading-[10px] text-[18px] py-3 px-4",
};

export type TagSize = keyof typeof SIZES;

export interface TagProps {
	theme?: keyof typeof THEMES;
	custom?: string;
	size: TagSize;
	children?: any;
	onClick?: () => void;
	className?: string;
	options?: {
		closeable?: boolean;
	};
}

const Tag = ({
	theme,
	custom,
	size,
	children,
	onClick,
	className: _className,
	options,
}: TagProps) => {
	let style = {};
	let className = `gap-2 ${
		onClick && "cursor-pointer"
	} inline-flex items-center flex-row transition-all relative  ${
		SIZES[size]
	} ${_className || ""}`;

	if (!className?.includes("w-")) {
		className += `  w-max`;
	}

	if (!className?.includes("font-")) {
		className += ` font-bold`;
	}

	if (!className?.includes("bg-") && theme) {
		className += ` ${THEMES[theme]}`;
	}

	if (!className?.includes("rounded-")) {
		className += `  rounded-md`;
	}

	if (custom) {
		style = {
			...(style || {}),
			backgroundColor: hexToRGB(custom, 0.1),
			color: custom,
		};
	}

	return (
		<div {...{ className, onClick, style }}>
			{children}
			{options?.closeable && (
				<div className="w-5 h-5 flex justify-center items-center bg-dark/10 rounded-sm">
					<i className="fas fa-times text-[12px]"></i>
				</div>
			)}
		</div>
	);
};

Tag.defaultProps = {
	theme: "gray",
	size: "default",
};

export default Tag;
